import { SeverityLevel } from '@sentry/react';

export const CRITICAL: SeverityLevel = 'fatal';

export const ERROR: SeverityLevel = 'error';

export const WARNING: SeverityLevel = 'warning';

export const ERROR_LEVELS = {
    CRITICAL,
    ERROR,
    WARNING,
};
